import React from 'react';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';

import Login from '@containers/admin/Login';
import Alert from '@containers/common/Alert';

import PrivateRoute from '@components/PrivateRoute';

import { loginSuccess } from '@actions/auth';

import { getUserProfile, isLoggedIn } from '@utils/AuthUtil';

import Home from './Home';

interface IAppProps extends ICommonProps {
  loginSuccess: TLoginSuccess;
}

class App extends React.Component<IAppProps, any> {
  constructor(props) {
    super(props);

    if (isLoggedIn()) {
      const UserProfile: IUserProfile = getUserProfile();

      this.props.loginSuccess(UserProfile);
    }
  }

  render() {
    return (
      <Container fluid={true}>
        <Switch>
          <Route exact path="/login" component={Login} />
          <PrivateRoute path="/" component={Home} />
        </Switch>
        <Alert />
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  loginSuccess: (userProfile: IUserProfile) => dispatch(loginSuccess(userProfile)),
});

export default withRouter(connect(null, mapDispatchToProps)(App));
